import { useEffect, useMemo } from 'react';

import { Modals } from '@/helpers/modals';
import {
  AUTH_FIELD_MISSED_COUNTRY,
  AUTH_FIELD_MISSED_TERMS,
  GOOGLE_OAUTH_NAME,
} from '@/helpers/oauth';
import { useAuthProviders } from '@/modules/common/hooks/useAuthProviders';
import { clearGoogleOAuthAffiliateParams } from '@/modules/promo';
import { useGetCommonStore, useModalsStore } from '@/store';

export const useConfirmRegistrationOrTerms = () => {
  const useCommonStore = useGetCommonStore();

  const open = useModalsStore.use.open();
  const user = useCommonStore.use.user();
  const isAuthenticated = useCommonStore.use.isAuthenticated();

  const { data: authProviders, isLoading: pendingauthProviders } =
    useAuthProviders();

  const isRegisteredWithGoogle = useMemo(
    () => authProviders.some(({ name }) => name === GOOGLE_OAUTH_NAME),
    [authProviders]
  );

  const missedFields = user?.authFieldsMissed;

  const modalToOpen = useMemo(() => {
    if (!missedFields) return null;

    if (isRegisteredWithGoogle) {
      if (
        missedFields.includes(AUTH_FIELD_MISSED_COUNTRY) &&
        missedFields.includes(AUTH_FIELD_MISSED_TERMS)
      ) {
        return Modals.ConfirmGoogleRegistration;
      }

      if (missedFields.includes(AUTH_FIELD_MISSED_COUNTRY)) {
        return Modals.ConfirmGoogleCountry;
      }
    }

    if (missedFields.includes(AUTH_FIELD_MISSED_TERMS)) {
      return Modals.TermsAndConditionsAcceptance;
    }

    return null;
  }, [missedFields, isRegisteredWithGoogle]);

  useEffect(() => {
    if (pendingauthProviders || !isAuthenticated) return;

    if (modalToOpen) {
      open(modalToOpen);
    } else {
      clearGoogleOAuthAffiliateParams();
    }
  }, [pendingauthProviders, isAuthenticated, modalToOpen, open]);
};
